"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _link = _interopRequireDefault(require("next/link"));

var _router = require("next/router");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Custom active link from: https://github.com/zeit/next.js/pull/8558
 *
 * We specify all props that link accepts because if we
 * provide any extra props Link will throw an error
 *
 * An example is, when extending Link for Button usage,
 * Button provides many new style props, which in turn trigger an error
 */
var GenericLink = function GenericLink(_ref) {
  var children = _ref.children,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      href = _ref.href,
      as = _ref.as,
      replace = _ref.replace,
      scroll = _ref.scroll,
      shallow = _ref.shallow,
      _ref$passHref = _ref.passHref,
      passHref = _ref$passHref === void 0 ? true : _ref$passHref,
      prefetch = _ref.prefetch,
      dataTestid = _ref['data-testid'],
      ariaLabel = _ref['aria-label'],
      linkProps = _ref.linkProps,
      disableIfActive = _ref.disableIfActive;

  var _ref2 = (0, _router.useRouter)() || {},
      _ref2$pathname = _ref2.pathname,
      pathname = _ref2$pathname === void 0 ? '' : _ref2$pathname;

  var child = _react.Children.only(children);

  var isActive = pathname === href;
  var childClassName = isActive ? "".concat(child.props.className || className, " ").concat(activeClassName || '') : child.props.className || className;

  var renderChildren = function renderChildren() {
    return /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread({
      className: childClassName,
      'data-testid': dataTestid,
      'aria-label': ariaLabel
    }, linkProps));
  };

  return isActive && disableIfActive ? __jsx(_react["default"].Fragment, null, renderChildren()) : __jsx(_link["default"], {
    href: href,
    as: as,
    replace: replace,
    scroll: scroll,
    shallow: shallow,
    passHref: passHref,
    prefetch: prefetch
  }, renderChildren());
};

GenericLink.defaultProps = {
  activeClassName: null,
  linkProps: {},
  disableIfActive: false
};
var _default = GenericLink;
exports["default"] = _default;